export const config = {
  dateFormat: "DD MMMM YYYY, HH:mm"
};
